import { render, staticRenderFns } from "./FragmentsEditor.vue?vue&type=template&id=0f97a5b4&scoped=true"
import script from "./FragmentsEditor.vue?vue&type=script&lang=ts"
export * from "./FragmentsEditor.vue?vue&type=script&lang=ts"
import style0 from "./FragmentsEditor.vue?vue&type=style&index=0&id=0f97a5b4&prod&lang=scss"
import style1 from "./FragmentsEditor.vue?vue&type=style&index=1&id=0f97a5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f97a5b4",
  null
  
)

export default component.exports